import Interaction from "./Interaction";
import { InteractionType } from "./Interaction";
import { InteractionFactoryEntity } from "../../features/interaction_factory/InteractionFactory";
import { GetNewGuid } from "../../helpers/GuidHelper";
import { SearchResultData } from "../../app/slices/SearchResultsSlice";
import IfNodePreview from "../../features/sequence/node_previews/IfNodePreview";

export enum IfOperator {
  Equal = "EQUAL",
  NotEqual = "NOTEQUAL",
  Less = "LESS",
  LessOrEqual = "LEQUAL",
  Greater = "GREATER",
  GreaterOrEqual = "GEQUAL",
}

export const IF_OPERATOR_LABELS: Record<IfOperator, string> = {
  [IfOperator.Equal]: "Equal",
  [IfOperator.NotEqual]: "Not Equal",
  [IfOperator.Less]: "Less",
  [IfOperator.LessOrEqual]: "Less or Equal",
  [IfOperator.Greater]: "Greater",
  [IfOperator.GreaterOrEqual]: "Greater or Equal",
};

export interface IIf extends Interaction {
  variable: string; // Variable ID to compare
  match: string; // Variable ID or value to compare against
  operator: IfOperator;
}

export const ifInteraction = (): InteractionFactoryEntity => {
  const create = (getKeys: (amount: number) => string[]): IIf => {
    return {
      id: GetNewGuid(),
      name: "If",
      type: InteractionType.If,
      variable: "",
      match: "",
      operator: IfOperator.Equal,
    };
  };

  const migrate = (from: number, to: number, interaction: Interaction): IIf => {
    return interaction as IIf;
  };

  const copy = (
    interaction: Interaction,
    getKeys: (amount: number) => string[],
    replaceKey: (from: string, to: string) => void,
  ): IIf => {
    const original = interaction as IIf;
    return {
      id: GetNewGuid(),
      name: "If",
      type: InteractionType.If,
      variable: original.variable,
      match: original.match,
      operator: original.operator,
    };
  };

  const validate = (
    interaction: Interaction,
    getValue: (key: string) => string,
  ): string[] => {
    const warnings: string[] = [];
    return warnings;
  };

  const filterType = "If";

  const filter = (
    interaction: Interaction,
    takeName: string,
    getMatchingResults: (
      searchableStrings: string[],
      takeName: string,
      interaction: Interaction,
      filterType: string,
    ) => SearchResultData[],
  ): SearchResultData[] => {
    return getMatchingResults(
      [interaction.name],
      takeName,
      interaction,
      filterType,
    );
  };

  const validateError = (interaction: Interaction): string[] => {
    const casted = interaction as IIf;
    const errors: string[] = [];

    if (!casted.variable) {
      errors.push("Please select a variable to compare");
    }

    return errors;
  };

  return {
    View: <div>If Node</div>,
    NodeView: (nodeId: string, interaction: Interaction) => (
      <IfNodePreview nodeId={nodeId} interaction={interaction} />
    ),
    Create: create,
    FilterType: filterType,
    Migrate: migrate,
    Copy: copy,
    Validate: validate,
    Filter: filter,
    ValidateErrors: validateError,
  };
};
